import type { ReferralLinkStatisticsSchema } from "@biteasy/contracts";
import type { z } from "zod";
import { formatCurrency } from "@/util/format";

interface StatisticsCardsProps {
	statistics: z.infer<typeof ReferralLinkStatisticsSchema>;
}

export function StatisticsCards({ statistics }: StatisticsCardsProps) {
	const stats = [
		{
			label: "Deferred",
			value: statistics.deferCount.toLocaleString(),
			description: "Times link was visited",
		},
		{
			label: "Claimed",
			value: statistics.claimCount.toLocaleString(),
			description: "Successful attributions",
		},
		{
			label: "Total Earnings",
			value: formatCurrency(statistics.totalEarnings, statistics.currency),
			description: "Revenue generated",
		},
		{
			label: "Partner Received",
			value: formatCurrency(statistics.partnerReceived, statistics.currency),
			description: "Paid to partner",
		},
	];

	return (
		<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
			{stats.map((stat) => (
				<div
					key={stat.label}
					className="rounded-xl border border-base-content/10 bg-base-100 p-6"
				>
					<div className="text-sm font-medium text-base-content/60">
						{stat.label}
					</div>
					<div className="mt-2 text-3xl font-bold text-base-content">
						{stat.value}
					</div>
					<div className="mt-1 text-xs text-base-content/50">
						{stat.description}
					</div>
				</div>
			))}
		</div>
	);
}
